// extracted by mini-css-extract-plugin
export default {"menuBarRoot":"tKIPFmBV","hasActionBars":"dj3AG6AS","menuGridRoot":"jjlOAWqm"};